import { useEffect } from "react";
import { Outlet } from "react-router";
import { SkipLink } from "./SkipLink";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";
import { ConsentBanner } from "./ConsentBanner";
import { initAnalyticsFromStorage } from "../../lib/analytics";

export function RootLayout() {
  useEffect(() => {
    initAnalyticsFromStorage();
  }, []);

  return (
    <>
      <SkipLink />
      <ScrollToTop />
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      <ConsentBanner />
    </>
  );
}
